"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_designer_constants_1 = require("../components/designer/form/form-designer.constants");
var DragulaDomElementInfo = /** @class */ (function () {
    function DragulaDomElementInfo(value) {
        this.bagName = value[0], this.elem = value[1], this.container = value[2], this.source = value[3];
    }
    DragulaDomElementInfo.prototype.elemId = function () {
        return this.elem.id;
    };
    DragulaDomElementInfo.prototype.elemIdEquals = function (idToCompare) {
        return this.elem.id === idToCompare;
    };
    DragulaDomElementInfo.prototype.containerIdEquals = function (idToCompare) {
        return this.container.id === idToCompare;
    };
    DragulaDomElementInfo.prototype.sourceIdEquals = function (idToCompare) {
        return this.source.id === idToCompare;
    };
    DragulaDomElementInfo.prototype.bagNameEquals = function (nameToCompare) {
        return this.bagName === nameToCompare;
    };
    DragulaDomElementInfo.prototype.getElemColumnCount = function () {
        return this.elem.getAttribute('controller_col_count');
    };
    DragulaDomElementInfo.prototype.addClassToElem = function (className) {
        this.elem.classList.add(className);
    };
    DragulaDomElementInfo.prototype.getClasses = function () {
        return this.elem.classList;
    };
    DragulaDomElementInfo.prototype.getElem = function () {
        return this.elem;
    };
    DragulaDomElementInfo.prototype.removeClassFromElem = function (className) {
        this.elem.classList.remove(className);
    };
    DragulaDomElementInfo.prototype.addDisplayInlineToElem = function () {
        this.elem.style.display = 'inline';
    };
    DragulaDomElementInfo.prototype.getContainerAttribute = function (attrName) {
        return this.container.getAttribute(attrName);
    };
    DragulaDomElementInfo.prototype.isContainerNestedCard = function () {
        return (this.containerIdEquals(form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_UPPER_ROW_CONTAINER) ||
            this.containerIdEquals(form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_LOWER_ROW_CONTAINER) ||
            this.containerIdEquals(form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_ROW_CONTAINER));
    };
    DragulaDomElementInfo.prototype.isSourceNestedCard = function () {
        return (this.sourceIdEquals(form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_UPPER_ROW_CONTAINER) ||
            this.sourceIdEquals(form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_LOWER_ROW_CONTAINER) ||
            this.sourceIdEquals(form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_ROW_CONTAINER));
    };
    DragulaDomElementInfo.prototype.getElemAttribute = function (attrName) {
        return this.elem.getAttribute(attrName);
    };
    DragulaDomElementInfo.prototype.getSourceAttribute = function (attrName) {
        return this.source.getAttribute(attrName);
    };
    DragulaDomElementInfo.prototype.getDestinationNestedCardId = function () {
        return this.getContainerAttribute(form_designer_constants_1.FormDesignerConstants.NESTED_CARD_IDENTITY_ATTRIBUTE);
    };
    DragulaDomElementInfo.prototype.getSourceNestedCardId = function () {
        return this.getSourceAttribute(form_designer_constants_1.FormDesignerConstants.NESTED_CARD_IDENTITY_ATTRIBUTE);
    };
    DragulaDomElementInfo.prototype.getControllerId = function () {
        return this.getElemAttribute(form_designer_constants_1.FormDesignerConstants.CONTROLLER_ID);
    };
    DragulaDomElementInfo.prototype.getSourceCardId = function () {
        return this.getSourceAttribute(form_designer_constants_1.FormDesignerConstants.CARD_IDENTITY_ATTRIBUTE);
    };
    DragulaDomElementInfo.prototype.getDestinationCardId = function () {
        return this.getContainerAttribute(form_designer_constants_1.FormDesignerConstants.CARD_IDENTITY_ATTRIBUTE);
    };
    DragulaDomElementInfo.prototype.getDestinationRowId = function () {
        return this.getContainerAttribute(form_designer_constants_1.FormDesignerConstants.CONTROLLERS_ROW_ID_ATTRIBUTE);
    };
    DragulaDomElementInfo.prototype.getSourceRowId = function () {
        return this.getSourceAttribute(form_designer_constants_1.FormDesignerConstants.CONTROLLERS_ROW_ID_ATTRIBUTE);
    };
    DragulaDomElementInfo.prototype.getDestinationNestedRowId = function () {
        return this.getContainerAttribute(form_designer_constants_1.FormDesignerConstants.NESTED_CARD_CONTROLLERS_ROW_ID_ATTRIBUTE);
    };
    DragulaDomElementInfo.prototype.getSourceNestedRowId = function () {
        return this.getSourceAttribute(form_designer_constants_1.FormDesignerConstants.NESTED_CARD_CONTROLLERS_ROW_ID_ATTRIBUTE);
    };
    DragulaDomElementInfo.prototype.itemInUpperRow = function () {
        return this.containerIdEquals(form_designer_constants_1.FormDesignerConstants.UPPER_ROW_CONTAINER);
    };
    DragulaDomElementInfo.prototype.itemInNestedUpperRow = function () {
        return this.containerIdEquals(form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_UPPER_ROW_CONTAINER);
    };
    DragulaDomElementInfo.prototype.itemInRow = function () {
        return this.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLERS_ROW_CONTAINER);
    };
    DragulaDomElementInfo.prototype.itemInNestedRow = function () {
        return this.containerIdEquals(form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_ROW_CONTAINER);
    };
    DragulaDomElementInfo.prototype.itemInLayout = function () {
        return this.elemIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLER_CONTENT);
    };
    DragulaDomElementInfo.prototype.itemInLowerRow = function () {
        return this.containerIdEquals(form_designer_constants_1.FormDesignerConstants.LOWER_ROW_CONTAINER);
    };
    DragulaDomElementInfo.prototype.itemInNestedLowerRow = function () {
        return this.containerIdEquals(form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_LOWER_ROW_CONTAINER);
    };
    DragulaDomElementInfo.prototype.itemInTrash = function () {
        return this.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLER_TRASH_BIN);
    };
    return DragulaDomElementInfo;
}());
exports.DragulaDomElementInfo = DragulaDomElementInfo;
//# sourceMappingURL=dragula-dom-element.info.js.map